<template>
    <client-page class="app--main">
        <v-container class="container--large">
            <main-visual code="expo-program-pc" pc />
            <main-visual code="expo-program-mobile" mobile />
        </v-container>

        <section class="section">
            <v-container class="container--large">
                <expo-program-list-filter v-bind="{ loading }" class="mb-10 mb-md-20 mb-lg-28" />

                <template v-if="items.length">
                    <v-row class="my-n10 my-lg-n20">
                        <template v-for="item in items">
                            <v-col cols="12" sm="6" md="3" :key="item._id" class="py-10 py-lg-20">
                                <expo-program-item :value="item" />
                            </v-col>
                        </template>
                    </v-row>

                    <div class="mt-40 mt-lg-60">
                        <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-16" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
                    </div>
                </template>
                <template v-else>
                    <v-layout column justify-center align-center class="page-text page-text--lg border-top pt-12 pt-lg-20"> 등록된 프로그램이 없습니다. </v-layout>
                </template>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import api from "@/api";
import { initExpoProgram } from "@/assets/variables/inits";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import MainVisual from "@/components/client/main/main-visual.vue";

import ExpoProgramItem from "@/components/client/expo/programs/expo-program-item.vue";
import ExpoProgramListFilter from "@/components/client/expo/programs/expo-program-list-filter.vue";

export default {
    components: {
        ClientPage,
        MainVisual,

        ExpoProgramItem,
        ExpoProgramListFilter,
    },
    data: () => ({
        programs: [],

        limit: 16,
        summary: { totalCount: 0 },

        loading: false,
        showsSearch: true,
    }),
    computed: {
        items() {
            return this.programs.map((item, index) => initExpoProgram({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        sort() {
            let { sort } = this.$route.query;
            return sort;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            query.mode = query.mode ?? "on-going";

            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            this.loading = true;
            try {
                let { skip, limit, sort, params } = this;

                var { summary, programs } = await api.v1.expo.programs.gets({
                    headers: { skip, limit, sort },
                    params,
                });

                this.programs = programs;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
